export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-tablet-landscape-65addd97ea3befeda2fbca9b8077c157.svg";